/* Local text filtering only. Native details remain usable without this script. */
(() => {
  const normalize = value => value.toLocaleLowerCase('de').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss');
  function init(root) {
    if (root.dataset.faqReady) return;
    const input = root.querySelector('[data-faq-search]');
    const reset = root.querySelector('[data-faq-reset]');
    const buttons = [...root.querySelectorAll('[data-faq-filter]')];
    const groups = [...root.querySelectorAll('[data-faq-group]')];
    const entries = [...root.querySelectorAll('[data-faq-question]')].map(node => ({node, group: node.closest('[data-faq-group]').dataset.faqGroup, text: normalize(node.textContent)}));
    const status = root.querySelector('[data-faq-status]');
    let selected = 'all';
    function filter() {
      const words = normalize(input.value).trim().split(/\s+/).filter(Boolean);
      let count = 0;
      entries.forEach(({node, group, text}) => {
        const match = (selected === 'all' || group === selected) && words.every(word => text.includes(word));
        node.hidden = !match;
        if (match) count++;
      });
      groups.forEach(group => { group.hidden = !group.querySelector('[data-faq-question]:not([hidden])'); });
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.faqFilter === selected)));
      reset.hidden = !input.value.trim() && selected === 'all';
      status.textContent = document.documentElement.lang === 'en' ? (count === 1 ? '1 question found' : `${count} questions found`) : (count === 1 ? '1 Frage gefunden' : `${count} Fragen gefunden`);
      root.querySelector('[data-faq-empty]').hidden = count !== 0;
    }
    function clear() { input.value = ''; selected = 'all'; filter(); }
    function revealHash(focus = false) {
      let id;
      try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
      const entry = entries.find(({node}) => node.id === id);
      if (!entry) return;
      clear();
      entry.node.open = true;
      requestAnimationFrame(() => {
        entry.node.scrollIntoView({block: 'start', behavior: 'instant'});
        if (focus) entry.node.querySelector('summary').focus({preventScroll: true});
      });
    }
    input.addEventListener('input', filter);
    input.addEventListener('search', filter);
    reset.addEventListener('click', () => { clear(); input.focus(); });
    buttons.forEach(button => button.addEventListener('click', () => { selected = button.dataset.faqFilter; filter(); }));
    root.addEventListener('click', event => {
      const anchor = event.target.closest('a[href^="#faq-"]');
      if (!anchor || !entries.some(({node}) => '#' + node.id === anchor.getAttribute('href'))) return;
      event.preventDefault();
      event.stopPropagation();
      history.pushState(null, '', anchor.getAttribute('href'));
      revealHash(true);
    });
    const onHash = () => { if (root.isConnected) revealHash(true); };
    window.addEventListener('hashchange', onHash);
    root.addEventListener('shopify:section:unload', () => window.removeEventListener('hashchange', onHash), {once: true});
    filter();
    root.querySelector('[data-faq-tools]').hidden = false;
    root.querySelector('[data-faq-fallback]').hidden = true;
    root.dataset.faqReady = 'true';
    revealHash();
  }
  function scan() { document.querySelectorAll('[data-yk-faq]').forEach(init); }
  scan();
  document.addEventListener('shopify:section:load', scan);
})();

/* Setup uses the same native disclosures, with local hash and focus navigation. */
(() => {
  function initSetup(root) {
    if (root.dataset.setupReady) return;
    root.dataset.setupReady = 'true';
    const panels = [...root.querySelectorAll('[data-setup-panel]')];
    const choices = [...root.querySelectorAll('[data-setup-choice]')];
    const tasks = [...root.querySelectorAll('.yk-setup__task')];
    const desktop = matchMedia('(min-width: 1000px)');
    let frame;
    const syncDisclosure = detail => {
      detail.querySelector('summary').setAttribute('aria-expanded', String(detail.open));
    };
    const active = panel => choices.forEach(a => {
      if (panel && a.dataset.setupChoice === panel.dataset.setupPanel) a.setAttribute('aria-current', 'location');
      else a.removeAttribute('aria-current');
    });
    function findTarget(hash) {
      let id;
      try { id = decodeURIComponent(hash.slice(1)); } catch { return null; }
      return [...root.querySelectorAll('[id]')].find(node => node.id === id);
    }
    function reveal(hash, focus) {
      const target = findTarget(hash);
      if (!target) return;
      const panel = target.matches('[data-setup-panel]') ? target : target.closest('[data-setup-panel]');
      if (panel) {
        panel.open = true;
        syncDisclosure(panel);
        active(panel);
      }
      cancelAnimationFrame(frame);
      const focusTarget = target.matches('details') ? target.querySelector('summary') : target;
      if (focus) focusTarget.focus({preventScroll: true});
      frame = requestAnimationFrame(() => {
        target.scrollIntoView({block: 'start', behavior: 'instant'});
      });
    }
    function layoutTasks() { tasks.forEach(task => { task.open = desktop.matches; syncDisclosure(task); }); }
    layoutTasks();
    desktop.addEventListener('change', layoutTasks);
    [...tasks, ...panels].forEach(detail => {
      syncDisclosure(detail);
      detail.addEventListener('toggle', () => {
        syncDisclosure(detail);
        if (detail.open && detail.matches('[data-setup-panel]')) active(detail);
      });
    });
    root.addEventListener('click', event => {
      const anchor = event.target.closest('a[href^="#"]');
      if (!anchor || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const hash = anchor.getAttribute('href');
      if (!findTarget(hash)) return;
      event.preventDefault();
      event.stopPropagation();
      if (location.hash !== hash) history.pushState(null, '', hash);
      if (!desktop.matches && anchor.hasAttribute('data-setup-choice')) {
        const task = anchor.closest('.yk-setup__task');
        if (task) { task.open = false; syncDisclosure(task); }
      }
      reveal(hash, true);
    });
    const onHistory = () => { if (root.isConnected) reveal(location.hash, true); };
    window.addEventListener('hashchange', onHistory);
    window.addEventListener('popstate', onHistory);
    root.addEventListener('shopify:section:unload', () => {
      window.removeEventListener('hashchange', onHistory);
      window.removeEventListener('popstate', onHistory);
      desktop.removeEventListener('change', layoutTasks);
      cancelAnimationFrame(frame);
    }, {once: true});
    reveal(location.hash, false);
  }
  const scan = () => document.querySelectorAll('[data-yk-setup]').forEach(initSetup);
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
